import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpClient from "../helpers/httpClient";

const initialState = {
  orders: {
    data: [],
    loading: false,
    error: null,
  },
  selectedOrder: {
    data: {},
    loading: false,
  },
  monthlyOrdersCount: {
    data: [],
    loading: false,
  },
  dashboardStats: {
    data: [],
    loading: false,
  },
};

export const getAllOrders = createAsyncThunk(
  "orders/getAllOrders",
  async () => {
    try {
      const response = await httpClient.get("/web/orders");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getOrderById = createAsyncThunk(
  "orders/getOrderById",
  async (id) => {
    try {
      const response = await httpClient.get(`/web/order/${id}`);
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const changeOrderStatus = createAsyncThunk(
  "orders/changeOrderStatus",
  async (payload) => {
    try {
      const response = await httpClient.patch(
        `/web/orders/${payload._id}/status`,
        {
          status: payload?.newStatus,
        }
      );
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getOrderByDateAndStatus = createAsyncThunk(
  "orders/getOrderByDateAndStatus",
  async (payload) => {
    try {
      const response = await httpClient.get(
        `/web/orders/${payload.status}/${payload.day}`
      );
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getMonthlyOrdersCount = createAsyncThunk(
  "orders/getMonthlyOrdersCount",
  async () => {
    try {
      const response = await httpClient.get("/web/orders-stats/monthly");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getDashboardStats = createAsyncThunk(
  "orders/getDashboardStats",
  async () => {
    try {
      const response = await httpClient.get("/web/orders-stats/dashboard");
      return response.data.res;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrders.pending, (state) => {
        state.orders.loading = true;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.orders.loading = false;
        state.orders.data = action.payload;
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.orders.loading = false;
        state.orders.error = action.error.message;
      })
      .addCase(getOrderById.pending, (state) => {
        state.selectedOrder.loading = true;
      })
      .addCase(getOrderById.fulfilled, (state, action) => {
        state.selectedOrder.loading = false;
        state.selectedOrder.data = action.payload;
      })
      .addCase(getOrderById.rejected, (state, action) => {
        state.selectedOrder.loading = false;
        state.selectedOrder.error = action.error.message;
      })
      .addCase(changeOrderStatus.fulfilled, (state, action) => {
        state.selectedOrder.loading = false;
        const index = state.orders.data.findIndex(
          (order) => order._id === action.payload._id
        );
        state.orders.data[index] = action.payload;
        state.selectedOrder.data = action.payload;
      })
      .addCase(changeOrderStatus.rejected, (state) => {
        state.selectedOrder.loading = false;
      })
      .addCase(changeOrderStatus.pending, (state) => {
        state.selectedOrder.loading = true;
      })
      .addCase(getOrderByDateAndStatus.pending, (state) => {
        state.orders.loading = true;
      })
      .addCase(getOrderByDateAndStatus.fulfilled, (state, action) => {
        state.orders.loading = false;
        state.orders.data = action.payload;
      })
      .addCase(getOrderByDateAndStatus.rejected, (state, action) => {
        state.orders.loading = false;
        state.orders.error = action.error.message;
      })
      .addCase(getMonthlyOrdersCount.pending, (state) => {
        state.monthlyOrdersCount.loading = true;
      })
      .addCase(getMonthlyOrdersCount.fulfilled, (state, action) => {
        state.monthlyOrdersCount.loading = false;
        state.monthlyOrdersCount.data = action.payload;
      })
      .addCase(getMonthlyOrdersCount.rejected, (state) => {
        state.monthlyOrdersCount.loading = false;
      })
      .addCase(getDashboardStats.pending, (state) => {
        state.dashboardStats.loading = true;
      })
      .addCase(getDashboardStats.fulfilled, (state, action) => {
        state.dashboardStats.loading = false;
        state.dashboardStats.data = action.payload;
      })
      .addCase(getDashboardStats.rejected, (state) => {
        state.dashboardStats.loading = false;
      });
  },
});

export default orderSlice.reducer;
